<div class="agent-card" [class.locked]="isLocked"
     [style.border-top-color]="agent.accentColor">
  <div class="agent-card__header">
    <span class="agent-card__icon">{{ agent.icon }}</span>
    <div class="agent-card__info">
      <span class="agent-card__code">{{ agent.code }}</span>
      <span class="agent-card__name">{{ agent.nameKey | translate }}</span>
    </div>
  </div>
  <div class="agent-card__footer">
    <span class="agent-card__status" *ngIf="!isLocked">
      <span class="agent-card__dot" [style.background]="agent.status === 'active' ? '#2E7D32' : '#9CA3AF'"></span>
      {{ agent.status === 'active' ? 'Activo' : 'Disponible' }}
    </span>
    <span class="agent-card__status locked" *ngIf="isLocked">
      🔒 {{ 'chatAi.agents.directory.locked' | translate }}
    </span>
    <button *ngIf="!isLocked" class="agent-card__talk"
            [style.background]="agent.accentColor"
            (click)="talk.emit(agent.code)">
      {{ 'chatAi.agents.directory.talkBtn' | translate }}
    </button>
  </div>
</div>
